module.exports = __webpack_public_path__ + "static/media/dove.4e3c3072.png";